export default __webpack_public_path__ + "media/images/distribution-af2a31fd90534aef80f9e48806232002.svg";